<div class="basic-card" [ngClass]="nzClass">
    <ng-container *ngTemplateOutlet="basicCardBody"></ng-container>
    <ng-content></ng-content>
</div>
